import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import { WorkbenchMobileContextMenuSchema } from '@tencent/workbench';
import { COMMON_MOBILE_CONTEXT_MENU } from '@framework/workbench/schema/context-menu-schema/common/mobile';


export const MOBILE_CONTEXT_MENU: WorkbenchMobileContextMenuSchema = [
    ...COMMON_MOBILE_CONTEXT_MENU,
    ActionType.VIEW_ATTACHMENT,
    ActionType.DOWNLOAD_ATTACHMENT,
    ActionType.SWITCH_ATTACHMENT_SHOWTYPE,
    ActionType.MOBILE_OCR,
    ActionType.MOBILE_ROTATE,
    ActionType.HIDE_SLIDE,
    ActionType.CANCEL_HIDE_SLIDE,
    ActionType.AI_REPLACE_SLIDE,
    ActionType.AI_WRITE_MOBILE,
    ActionType.AI_GENERATE_PAGE_MOBILE,
    ActionType.DELETE,
    ActionType.DELETE_ATTACHMENT,
];
